import { userStore } from '@/store/user-store';
import useConverter from '@/composables/general/useConverter';
import { projectStore } from '@/store/project-store';
import { IThought } from '@/models/thought.model';

// Checks permission regarding thought (e.g. editing, etc.)
export default function () {
  const { toBool } = useConverter();
  /**
   * Whether user is allowed to edit the thought
   * @param thought thought object
   * @param topic topic object (config)
   * @returns true|false
   */
  function canEditThought(thought: IThought) {
    if (!thought.owner) return false;
    if (thought._permissions) {
      return thought._permissions.update;
    }
    const topic = projectStore.getFetchedTopic(thought.topic.id);
    if (topic) {
      if (!toBool(topic.new_thoughts)) return false;
      if (!(toBool(topic.edit_checked_thoughts) || toBool(thought.content_checked == 'unchecked'))) return false;
    }
    if (!userStore.getIsInitialized()) return false;
    const user = userStore.getState().user;
    if (user) {
      return user.id == thought.owner.id;
    }
    return false;
  }

  function canShowSocialShare(thought: IThought) {
    return thought.content_checked == 'ok' && thought.status == 'show';
  }

  function thoughtIsAnonym(thought: IThought) {
    return !thought.owner || toBool(thought.anon);
  }

  return { canEditThought, thoughtIsAnonym, canShowSocialShare };
}
